<div class="row mb-1 mt-1">
  <div class="col col-auto">
    <div class="payment-badge"><img class="img-fluid" src="/assets/icons/payment/sepa.svg" [alt]="bankImgAlt()" /></div>
  </div>
  <div class="col">
    <p class="mb-0" [innerHTML]="bankDataText()"></p>
  </div>
</div>
